export const documentTypes = [
  {
    uid: 1,
    id: 'DOCUMENT_PASSPORT',
    name: 'Паспорт',
  },
  {
    uid: 3,
    id: 'DOCUMENT_ID_CARD',
    name: 'ID карта',
  },
  {
    uid: 4,
    id: 'DOCUMENT_DRIVERS_LICENSE',
    name: 'Водійське посвідчення',
  },

  {
    uid: 5,
    id: 'DOCUMENT_CHERNOBYL_VICTIM',
    key: 'e_retired',
    name: 'Посвідчення учасника ліквідації ядерних аварій',
  },
  {
    uid: 6,
    id: 'DOCUMENT_HANDICAPPED',
    name: 'Посвідчення інваліда',
  },
  {
    uid: 7,
    id: 'DOCUMENT_RETIREE',
    name: 'Пенсійне посвідчення',
  },
  /*{
    uid: 8,
    id: 'DOCUMENT_E_RETIREE',
    name: 'Електронне пенсійне посвідчення',
  },*/
  {
    uid: 8,
    id: 'DOCUMENT_HANDICAPPED_I_GROUP',
    name: 'Посвідчення інваліда I групи',
  },
  {
    uid: 15,
    id: 'DOCUMENT_HANDICAPPED_II_GROUP',
    name: 'Посвідчення інваліда II групи',
  },
  {
    uid: 9,
    id: 'DOCUMENT_VETERAN_CERTIFICATE',
    name: 'Посвідчення учасник військових дій',
  },
  {
    id: 'DOCUMENT_UBD_CERTIFICATE',
    name: 'Посвідчення учасника бойових дій',
  },

  {
    uid: 2,
    id: 'DOCUMENT_EXTERNAL_PASSPORT',
    name: 'Закордонний паспорт',
  },
  {
    uid: 10,
    id: 'DOCUMENT_FOREIGN_PASSPORT',
    name: 'Іноземний паспорт',
  },
  {
    uid: 11,
    id: 'DOCUMENT_RESIDENCE_PERMIT',
    name: 'Вид на проживання',
  },
  {
    uid: 12,
    id: 'DOCUMENT_ID_RESIDENCE_PERMIT',
    name: 'ID-вид на проживання',
  },
  {
    uid: 13,
    id: 'DOCUMENT_REGISTRATION_CARD',
    name: 'Регістраційний талон',
  },
  {
    uid: 14,
    id: 'DOCUMENT_BIRTH_CERTIFICATE',
    name: 'Свідоцтво про народження',
  },
  {
    uid: 99,
    id: 'DOCUMENT_OTHER',
    name: 'Інший документ',
  },
];

export const documentsWithExpiry = [
  'DOCUMENT_ID_CARD',
  'DOCUMENT_EXTERNAL_PASSPORT',
  'DOCUMENT_DRIVERS_LICENSE',
  'DOCUMENT_ID_RESIDENCE_PERMIT',
  'DOCUMENT_RESIDENCE_PERMIT',
];

export const eRetireeDocumentIds = [
  'DOCUMENT_CHERNOBYL_VICTIM',
  'DOCUMENT_E_RETIREE',
];

export const commonDocumentTypes = documentTypes.filter(document => [
  'DOCUMENT_PASSPORT',
  'DOCUMENT_ID_CARD',
  'DOCUMENT_DRIVERS_LICENSE',
  'DOCUMENT_EXTERNAL_PASSPORT',
  'DOCUMENT_FOREIGN_PASSPORT',
  'DOCUMENT_RESIDENCE_PERMIT',
  'DOCUMENT_ID_RESIDENCE_PERMIT',
  'DOCUMENT_REGISTRATION_CARD',
  'DOCUMENT_BIRTH_CERTIFICATE',
  'DOCUMENT_OTHER',
].includes(document.id));
